module.exports = __webpack_public_path__ + "static/img/left-bottom-row-7.a649c1aa.webp";